//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../no/SelectTaggedObject.js";
import "../no/SelectObject.js";
let d=[[[0,"ArrowLength",1,1],[0,"ArrowheadAngle",1,1],[0,"ArrowheadLength",1,1],[0,"ArrowheadStyle",1,1],[0,"BorderToArrowDistance",1,1],[0,"CreateSectionLine",1,1],[0,"DisplayJisrotationLetter",1,1],[0,"DisplayLabel",1,1],[0,"Font",1,1],[0,"LabelLocation",1,1],[0,"Letter",1,1],[0,"LineLength",1,1],[0,"Offset",1,1],[1,"SelectLetter",0,"SelectTaggedObject",1],[0,"Standard",1,1],[0,"StubLength",1,1],[0,"UseOffset",1,1],[0,"Width",1,1]],[[[],"GetColor",{R_:{color:"NXColor"}},0,1],[["color"],"SetColor",{},1,1]],[]];
SPLM.Drawings.SectionLineStyleBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.SectionLineStyleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.SectionLineStyleBuilder.ArrowheadStyleType = Object.freeze({
    "Open" : "Open", "Closed" : "Closed", "Filled" : "Filled"});

SPLM.Drawings.SectionLineStyleBuilder.StandardStyle = Object.freeze({
    "AnsiStandard" : "AnsiStandard", "IsoStandard" : "IsoStandard", "Iso128Standard" : "Iso128Standard", "JisStandard" : "JisStandard", "GbStandard" : "GbStandard", "EskdStandard" : "EskdStandard"});

SPLM.Drawings.SectionLineStyleBuilder.FontStyle = Object.freeze({
    "None" : "None", "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "LongDashed" : "LongDashed", "DottedDashed" : "DottedDashed", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

SPLM.Drawings.SectionLineStyleBuilder.WidthStyle = Object.freeze({
    "Thin" : "Thin", "Normal" : "Normal", "Thick" : "Thick", "ThicknessOne" : "ThicknessOne", "ThicknessTwo" : "ThicknessTwo", "ThicknessThree" : "ThicknessThree", "ThicknessFour" : "ThicknessFour", "ThicknessFive" : "ThicknessFive", "ThicknessSix" : "ThicknessSix", "ThicknessSeven" : "ThicknessSeven", "ThicknessEight" : "ThicknessEight", "ThicknessNine" : "ThicknessNine"});

SPLM.Drawings.SectionLineStyleBuilder.LabelLocationStyle = Object.freeze({
    "OnArrow" : "OnArrow", "OnEnd" : "OnEnd"});

SPLM.Drawings.SectionLineStyleBuilder.CreateSectionLineType = Object.freeze({
    "WithView" : "WithView", "WithoutView" : "WithoutView"});

export default SPLM;